module.exports = __webpack_public_path__ + "img/avatar3.5f9c8b97.png";